import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;
  function gp5GoPos(n) {
    document.getElementById('gp5slide').setAttribute('class', `pos${n}`);
    document.getElementById('gp4eg-1').setAttribute('class', `pos${n}`);
    document.getElementById('gp4im-1').setAttribute('class', `pos${n}`);
    // 		gp4im-1
    document.getElementById('gns5-svg').setAttribute('class', `pos${n}`);
    document.getElementById('gn5-h3').setAttribute('class', `pos${n}`);
    document.getElementById('wtNotesSlide').setAttribute('class', `pos${n}`);
    document.getElementById('wt4cred').setAttribute('class', `pos${n}`);
    document.getElementById('gp5slideM').setAttribute('class', `pos${n}`);
  }
  function goNx() { gp5cpos++; if (gp5cpos >= 6) { gp5cpos = 1; }gp5GoPos(gp5cpos); }
  function goPv() { gp5cpos--; if (gp5cpos <= 0) { gp5cpos = 5; }gp5GoPos(gp5cpos); }
  document.getElementById('arwPrev').addEventListener('click', goPv);
  document.getElementById('arwNext').addEventListener('click', goNx);
  document.getElementById('arwNextM').addEventListener('click', goNx);
  document.getElementById('arwPrevM').addEventListener('click', goPv);
  var exc = document.querySelectorAll('#gp4eg-13>circle');
  for (var i = 0, e; e = exc[i]; i++) {
    	e.addEventListener('click', function () {
	    	gp5GoPos(this.getAttribute('data-p'));
    	});
  }
  var exc = document.querySelectorAll('#gp5cclM>circle');
  for (var i = 0, e; e = exc[i]; i++) {
    	e.addEventListener('click', function () {
	    	gp5GoPos(this.getAttribute('data-p'));
    	});
  }
  var gp5cpos = 1;
  let mX; let iX;

  function mL(e) {
    document.getElementById('gp4x-drag').removeEventListener('mousemove', mM);
    document.getElementById('gp4x-drag').removeEventListener('mouseleave', mL);
    mX = undefined;
    console.log(gp5cpos);

    if (((iX - e.screenX) > 100) && (gp5cpos != 5))goNx();
    if (((iX - e.screenX) < -100) && (gp5cpos != 1))goPv();


    document.getElementById('gp5adj').style.transition = 'transform 300ms ease-out';
    document.getElementById('gp5adj').style.transform = 'translate(0px,88px)';
  }
  function mM(e) {
    if (mX == undefined) return;
    document.getElementById('gp5adj').style.transform = `translate(${e.screenX - mX}px,88px)`;
  }
  document.getElementById('gp4x-drag').addEventListener('mousedown', (e) => {
    document.getElementById('gp5adj').style.transition = 'none';
    mX = iX = e.screenX;
    document.getElementById('gp4x-drag').addEventListener('mousemove', mM);
    document.getElementById('gp4x-drag').addEventListener('mouseleave', mL);
  });
  document.getElementById('gp4x-drag').addEventListener('mouseup', mL);

  let lastsX = 0;
  function mLM(e) {
    document.getElementById('gp4x-swipe').removeEventListener('touchmove', mM);
    document.getElementById('gp4x-swipe').removeEventListener('touchend', mL);
    mX = undefined;
    console.log(gp5cpos);

    if (((iX - lastsX) > 100) && (gp5cpos != 5))goNx();
    if (((iX - lastsX) < -100) && (gp5cpos != 1))goPv();


    document.getElementById('gp5adjM').style.transition = 'transform 300ms ease-out';
    document.getElementById('gp5adjM').style.transform = 'translate(0px,0px)';
  }
  function mMM(e) {
    if (mX == undefined) return;
    lastsX = e.touches[0].screenX;
    document.getElementById('gp5adjM').style.transform = `translate(${e.touches[0].screenX - mX}px,0px)`;
  }
  document.getElementById('gp4x-swipe').addEventListener('touchstart', (e) => {
    document.getElementById('gp5adjM').style.transition = 'none';
    mX = iX = e.touches[0].screenX;
    document.getElementById('gp4x-swipe').addEventListener('touchmove', mMM);
    document.getElementById('gp4x-swipe').addEventListener('touchend', mLM);
  });
  document.getElementById('gp4x-swipe').addEventListener('touchend', mLM);
}
